import type { PropsWithChildren, ReactNode } from 'react'

import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Typography from '@mui/material/Typography'

export { StyledCard }

interface Props {
  title: string
  buttonBar?: ReactNode
  id?: string
}

const StyledCard = ({
  children,
  title,
  buttonBar,
}: PropsWithChildren<Props>) => {
  return (
    <Card sx={{ mt: 3, mb: 2, w: '100%', pb: 4 }}>
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'stretch' }}>
          <Typography
            variant="h5"
            sx={{
              color: '#1a4d99',
              fontFamily: 'Aller',
              fontSize: '24px',
              fontWeight: 200,
              marginLeft: '8px',
              padding: '24px',
              width: '100%',
            }}
          >
            {title}
          </Typography>
          {buttonBar && <>{buttonBar}</>}
        </Box>
        <Box sx={{ width: '95%', mx: 'auto' }}>{children}</Box>
      </CardContent>
    </Card>
  )
}
